import { mapState, mapGetters, mapActions } from "vuex";

// Helper para filtros de clientes rurais
export const filtrosClientesRuraisHelper = (options = {}) => {
  const namespace = "astec/filtros/filtrosClientesRurais";

  const defaultState = [
    "email",
    "mesAno",
    "selecaoSafra",
    "selecaoProjeto",
    "selecaoCpfCnpj",
    "selecaoCooperado",
    "selecaoMunicipio",
    "selecaoClienteRural"
  ];

  const defaultGetters = ["filtroClientesRurais", "hasFiltrosAtivos"];

  const defaultActions = [
    "setFiltroCampo",
    "setOpcoesFiltro",
    "setFiltroClientesRurais",
    "limparFiltrosClientesRurais"
  ];

  const {
    state = defaultState,
    getters = defaultGetters,
    actions = defaultActions,
    includeAll = true
  } = options;

  const result = {};

  if (includeAll || state.length > 0) {
    result.computed = {
      ...(result.computed || {}),
      ...mapState(namespace, state)
    };
  }

  if (includeAll || getters.length > 0) {
    result.computed = {
      ...(result.computed || {}),
      ...mapGetters(namespace, getters)
    };
  }

  if (includeAll || actions.length > 0) {
    result.methods = {
      ...(result.methods || {}),
      ...mapActions(namespace, actions)
    };
  }

  return result;
};

// Helper para filtros de projetos
export const filtrosProjetosHelper = (options = {}) => {
  const namespace = "astec/filtros/filtrosProjetos";

  const defaultState = [
    "cdPessoa",
    "selecaoSafra",
    "numeroProjeto",
    "selecaoProjeto",
    "selecaoCooperado",
    "selecaoMunicipio",
    "selecaoTipoProjeto",
    "selecaoClienteRural",
    "selecaoLinhaCredito",
    "selecaoStatusProjeto",
    "selecaoItemAgropecuario",
    "selecaoModalidadeSeguro",
    "selecaoInstituicaoFinanceira"
  ];

  const defaultGetters = ["filtroProjetos", "hasFiltrosAtivos"];

  const defaultActions = [
    "setFiltroCampo",
    "setFiltroProjetos",
    "limparFiltrosProjetos"
  ];

  const {
    state = defaultState,
    getters = defaultGetters,
    actions = defaultActions,
    includeAll = true
  } = options;

  const result = {};

  if (includeAll || state.length > 0) {
    result.computed = {
      ...(result.computed || {}),
      ...mapState(namespace, state)
    };
  }

  if (includeAll || getters.length > 0) {
    result.computed = {
      ...(result.computed || {}),
      ...mapGetters(namespace, getters)
    };
  }

  if (includeAll || actions.length > 0) {
    result.methods = {
      ...(result.methods || {}),
      ...mapActions(namespace, actions)
    };
  }

  return result;
};

// Helper para filtros de lotes
export const filtrosLotesHelper = (options = {}) => {
  const namespace = "astec/filtros/filtrosLotes";

  const defaultState = [
    "cdPessoa",
    "selecaoLote",
    "cdPessoaNome",
    "selecaoStatus",
    "dataImportacao"
  ];
  const defaultGetters = ["filtroCompleto", "hasFiltrosAtivos"];
  const defaultActions = ["setFiltro", "limparFiltros"];

  const {
    state = defaultState,
    getters = defaultGetters,
    actions = defaultActions,
    includeAll = true
  } = options;

  const result = {};

  if (includeAll || state.length > 0) {
    result.computed = {
      ...(result.computed || {}),
      ...mapState(namespace, state)
    };
  }

  if (includeAll || getters.length > 0) {
    result.computed = {
      ...(result.computed || {}),
      ...mapGetters(namespace, getters)
    };
  }

  if (includeAll || actions.length > 0) {
    result.methods = {
      ...(result.methods || {}),
      ...mapActions(namespace, actions)
    };
  }

  return result;
};

// Helper para filtros de projetos do lote
export const filtrosProjetosLoteHelper = (options = {}) => {
  const namespace = "astec/filtros/filtrosProjetosLote";

  const defaultState = [
    "selecaoSafra",
    "selecaoProjeto",
    "selecaoLinhaCredito",
    "selecaoStatusImportacao",
    "selecaoModalidadeSeguro"
  ];

  const defaultGetters = ["hasFiltrosAtivos", "filtroProjetosLote"];

  const defaultActions = [
    "setFiltroCampo",
    "setFiltroProjetosLote",
    "limparFiltrosProjetosLote"
  ];

  const {
    state = defaultState,
    getters = defaultGetters,
    actions = defaultActions,
    includeAll = true
  } = options;

  const result = {};

  if (includeAll || state.length > 0) {
    result.computed = {
      ...(result.computed || {}),
      ...mapState(namespace, state)
    };
  }

  if (includeAll || getters.length > 0) {
    result.computed = {
      ...(result.computed || {}),
      ...mapGetters(namespace, getters)
    };
  }

  if (includeAll || actions.length > 0) {
    result.methods = {
      ...(result.methods || {}),
      ...mapActions(namespace, actions)
    };
  }

  return result;
};

// Helper genérico com configurável
export const paginacaoAsteсHelper = (options = {}) => {
  const namespace = options.namespace || "astec/paginacao/paginacaoGenerica";

  const defaultState = ["currentPage", "pageSize", "total", "loading"];
  const defaultGetters = [
    "currentPage",
    "pageSize",
    "total",
    "loading",
    "apiParams",
    "totalPages",
    "hasNextPage",
    "hasPrevPage",
    "rangeStart",
    "rangeEnd"
  ];
  const defaultActions = [
    "setPage",
    "setPageSize",
    "setTotal",
    "setLoading",
    "syncWithApi",
    "resetarPaginacao"
  ];

  const {
    state = defaultState,
    getters = defaultGetters,
    actions = defaultActions,
    includeAll = true
  } = options;

  const result = {};

  if (includeAll || state.length > 0) {
    result.computed = {
      ...(result.computed || {}),
      ...mapState(namespace, state)
    };
  }

  if (includeAll || getters.length > 0) {
    result.computed = {
      ...(result.computed || {}),
      ...mapGetters(namespace, getters)
    };
  }

  if (includeAll || actions.length > 0) {
    result.methods = {
      ...(result.methods || {}),
      ...mapActions(namespace, actions)
    };
  }

  return result;
};

// Helper específico para projetos
export const paginacaoProjetosHelper = (customOptions = {}) => {
  return paginacaoAsteсHelper({
    namespace: "astec/paginacao/paginacaoProjetos",
    includeAll: true,
    ...customOptions
  });
};

// Helper específico para cliente rural
export const paginacaoClientesRuraisHelper = (customOptions = {}) => {
  return paginacaoAsteсHelper({
    namespace: "astec/paginacao/paginacaoClienteRural",
    includeAll: true,
    ...customOptions
  });
};

// Helper específico para loteste por projeto
export const paginacaoProjetoPorLoteHelper = (customOptions = {}) => {
  return paginacaoAsteсHelper({
    namespace: "astec/paginacao/paginacaoProjetoPorLote",
    includeAll: true,
    ...customOptions
  });
};
